import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbAccordionConfig } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";

@Component({
  selector: "app-auditlog",
  templateUrl: "./auditlog.component.html",
  standalone: false,
})
export class AuditlogComponent implements OnInit {
  activeTabId: string = "pending-publish-tab-id";
  currentProject = {
    id: "",
    name: "",
    primaryLanguage: "",
    supportedLanguage: [],
  };
  selectedVersion: string = "";
  selectedEnv: string = "dev";
  selectedTransitOption: string = "lastTransit";
  selectedDate: Date | null = new Date();
  versionList = [];
  data: [];
  publishdata: any = {};
  currentPage: number = 1;
  totalPages: number = 1;
  isLoading: boolean = false;
  publishCurrentPage: number = 1;
  publishTotalPages: number = 1;
  loadingSub;
  auditTrailData: any = [];
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.loadingService.show();
    this.route.params.subscribe((params) => {
      let projectId = params["pid"];

      this.getProjectManagementData = this.getProjectManagementData.bind(this);
      this.getProjectManagementData(projectId);

      setTimeout(() => {
        this.getAuditData(projectId, this.selectedEnv, this.selectedVersion, 1);
        this.getPendingPublishData(
          projectId,
          this.selectedEnv,
          this.selectedVersion,
          1
        );
        this.getAuditTrailData(
          projectId,
          this.selectedEnv,
          this.selectedVersion,
          1
        );
        this.loadingService.hide();
      }, 2000);
    });
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }
  ngAfterViewInit() {
    // Set initial tab from hash
    this.setTabFromHash();
    window.addEventListener("hashchange", this.setTabFromHash.bind(this));
  }

  setTabFromHash() {
    const hash = window.location.hash.replace("#", "");
    switch (hash) {
      case "auditlog":
        this.activeTabId = "auditLog";
        break;
      default:
        this.activeTabId = "pendingPublish";
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getVersions(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.versionList = response;
        self.getLatestVersion(projectId);
      },
      "Versions?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getLatestVersion(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.selectedVersion = response.id;
        self.getAuditData(projectId, self.selectedEnv, self.selectedVersion, 1);
        self.getPendingPublishData(
          projectId,
          self.selectedEnv,
          self.selectedVersion,
          1
        );
        self.getAuditTrailData(
          projectId,
          self.selectedEnv,
          self.selectedVersion,
          1
        );
      },
      "Versions/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getProjectManagementData(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.currentProject = response;
        self.getVersions(projectId);
      },
      'projectManagements/findOne?filter={"where":{"id":"' + projectId + '"}}'
    );
  }

  onFilterChange() {
    // console.log("selected dropdows", this.selectedEnv);
    if (this.selectedTransitOption == "lastTransit" && this.selectedDate) {
      this.selectedDate = new Date();
    }
    this.getAuditData(
      this.currentProject.id,
      this.selectedEnv,
      this.selectedVersion,
      this.currentPage
    );
    this.getPendingPublishData(
      this.currentProject.id,
      this.selectedEnv,
      this.selectedVersion,
      this.publishCurrentPage
    );
    this.getAuditTrailData(
      this.currentProject.id,
      this.selectedEnv,
      this.selectedVersion,
      1
    );
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getAuditData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.currentPage
      );
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getAuditData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.currentPage
      );
    }
  }

  goToPublishPreviousPage() {
    if (this.publishCurrentPage > 1) {
      this.publishCurrentPage--;
      this.getPendingPublishData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.publishCurrentPage
      );
      this.getAuditTrailData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.publishCurrentPage
      );
    }
  }

  goToPublishNextPage() {
    if (this.publishCurrentPage < this.publishTotalPages) {
      this.publishCurrentPage++;
      this.getPendingPublishData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.publishCurrentPage
      );
      this.getAuditTrailData(
        this.currentProject.id,
        this.selectedEnv,
        this.selectedVersion,
        this.publishCurrentPage
      );
    }
  }

  getAuditData(projectId, publishStage, projectVersion, page = 1) {
    let self = this;
    var query = `?projectManagementId=${projectId}&publishStage=${publishStage}&projectVersion=${projectVersion}&page=${page}`;

    self.crudService.get(
      null,
      function (response) {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.data = response;
            self.totalPages = response.totalPages;
          }
        }
      },
      "projectManagements/getAuditLog" + query
    );
  }

  getAuditTrailData(
    projectId: string,
    publishStage: string,
    projectVersion: string,
    page = 1
  ) {
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.auditTrailData = response;
            this.publishTotalPages = response.totalPages;
            this.loadingService.hide();
          }
        }
      },
      `audittrails/getAuditTrail?projectManagementId=${projectId}&publishStage=${publishStage}&projectVersion=${projectVersion}&page=${page}`
    );
  }
  getPendingPublishData(
    projectId: string,
    publishStage: string,
    projectVersion: string,
    page = 1
  ) {
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.publishdata = response;
            this.publishTotalPages = response.totalPages;
          }
        }
      },
      `audittrails/getPendingPublish?projectManagementId=${projectId}&publishStage=${publishStage}&projectVersion=${projectVersion}&page=${page}`
    );
  }

  updatePublishStage(item, currentDeployedstatus) {
    // console.log("current deploy", item, currentDeployedstatus);
    var payload = item;

    if (item != undefined && item != null) {
      if (currentDeployedstatus == "dev") {
        if (item.length) {
          this.crudService.update(
            payload,
            (response) => {},
            `audittrails/publishAllToQA`
          );
          this.toastr.success("Successfully published to QA", "Success");
          this.ngOnInit();
        } else {
          this.crudService.update(
            payload,
            (response) => {},
            `audittrails/publishToQA`
          );
          this.toastr.success("Successfully published to QA", "Success");
          this.ngOnInit();
        }
      } else if (currentDeployedstatus == "qa") {
        if (item.length) {
          payload = item;

          this.crudService.update(
            payload,
            (response) => {},
            `audittrails/publishAllToProd`
          );
          this.toastr.success("Successfully published to prod", "Success");
          this.ngOnInit();
        } else {
          payload = item;
          this.crudService.update(
            payload,
            (response) => {},
            `audittrails/publishToProd`
          );
          this.toastr.success("Successfully published to prod", "Success");
          this.ngOnInit();
        }
      }
    }
  }
  onTabChange(tabName) {
    // Map tabName to hash
    let hash = "";
    switch (tabName) {
      case "auditLog":
      case "auditlog-tab-id":
        hash = "auditLog";
        this.activeTabId = "auditLog";
        break;

      default:
        hash = tabName;
        this.activeTabId = tabName;
    }
    if (hash) {
      this.router.navigate([], {
        fragment: hash,
        queryParamsHandling: "preserve",
      });
      this.loadingService.hide();
    }
  }
}
